import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PointsStore from "@/pages/PointsStore";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/points-store")({
  head: () => seoHead("/points-store"),
  component: () => (
    <AuthGate><PointsStore /></AuthGate>
  ),
});
